export * from './adminCompanies.service';
import { AdminCompaniesApiService } from './adminCompanies.service';
export * from './adminRoles.service';
import { AdminRolesApiService } from './adminRoles.service';
export * from './adminUserAccess.service';
import { AdminUserAccessApiService } from './adminUserAccess.service';
export * from './apiAccess.service';
import { ApiAccessApiService } from './apiAccess.service';
export * from './assetHistory.service';
import { AssetHistoryApiService } from './assetHistory.service';
export * from './assets.service';
import { AssetsApiService } from './assets.service';
export * from './assetsBulkEdit.service';
import { AssetsBulkEditApiService } from './assetsBulkEdit.service';
export * from './auth.service';
import { AuthApiService } from './auth.service';
export * from './collections.service';
import { CollectionsApiService } from './collections.service';
export * from './contactUs.service';
import { ContactUsApiService } from './contactUs.service';
export * from './content.service';
import { ContentApiService } from './content.service';
export * from './default.service';
import { DefaultApiService } from './default.service';
export * from './eventLog.service';
import { EventLogApiService } from './eventLog.service';
export * from './exports.service';
import { ExportsApiService } from './exports.service';
export * from './fileAccess.service';
import { FileAccessApiService } from './fileAccess.service';
export * from './forecast.service';
import { ForecastApiService } from './forecast.service';
export * from './history.service';
import { HistoryApiService } from './history.service';
export * from './informationBanner.service';
import { InformationBannerApiService } from './informationBanner.service';
export * from './loginHistory.service';
import { LoginHistoryApiService } from './loginHistory.service';
export * from './maconomy.service';
import { MaconomyApiService } from './maconomy.service';
export * from './monitor.service';
import { MonitorApiService } from './monitor.service';
export * from './projects.service';
import { ProjectsApiService } from './projects.service';
export * from './relations.service';
import { RelationsApiService } from './relations.service';
export * from './sharing.service';
import { SharingApiService } from './sharing.service';
export * from './systemPreference.service';
import { SystemPreferenceApiService } from './systemPreference.service';
export * from './tagGroups.service';
import { TagGroupsApiService } from './tagGroups.service';
export * from './tags.service';
import { TagsApiService } from './tags.service';
export * from './tasks.service';
import { TasksApiService } from './tasks.service';
export * from './taxonomy.service';
import { TaxonomyApiService } from './taxonomy.service';
export * from './teams.service';
import { TeamsApiService } from './teams.service';
export * from './teamsChangeLogs.service';
import { TeamsChangeLogsApiService } from './teamsChangeLogs.service';
export * from './uploads.service';
import { UploadsApiService } from './uploads.service';
export * from './userPreference.service';
import { UserPreferenceApiService } from './userPreference.service';
export * from './userRegistration.service';
import { UserRegistrationApiService } from './userRegistration.service';
export * from './users.service';
import { UsersApiService } from './users.service';
export * from './usersTagging.service';
import { UsersTaggingApiService } from './usersTagging.service';
export * from './valueLists.service';
import { ValueListsApiService } from './valueLists.service';
export * from './version.service';
import { VersionApiService } from './version.service';
export * from './web2print.service';
import { Web2printApiService } from './web2print.service';
export * from './wiki.service';
import { WikiApiService } from './wiki.service';
export * from './workflowTeams.service';
import { WorkflowTeamsApiService } from './workflowTeams.service';
export * from './workflows.service';
import { WorkflowsApiService } from './workflows.service';
export * from './workflowsAccess.service';
import { WorkflowsAccessApiService } from './workflowsAccess.service';
export const APIS = [AdminCompaniesApiService, AdminRolesApiService, AdminUserAccessApiService, ApiAccessApiService, AssetHistoryApiService, AssetsApiService, AssetsBulkEditApiService, AuthApiService, CollectionsApiService, ContactUsApiService, ContentApiService, DefaultApiService, EventLogApiService, ExportsApiService, FileAccessApiService, ForecastApiService, HistoryApiService, InformationBannerApiService, LoginHistoryApiService, MaconomyApiService, MonitorApiService, ProjectsApiService, RelationsApiService, SharingApiService, SystemPreferenceApiService, TagGroupsApiService, TagsApiService, TasksApiService, TaxonomyApiService, TeamsApiService, TeamsChangeLogsApiService, UploadsApiService, UserPreferenceApiService, UserRegistrationApiService, UsersApiService, UsersTaggingApiService, ValueListsApiService, VersionApiService, Web2printApiService, WikiApiService, WorkflowTeamsApiService, WorkflowsApiService, WorkflowsAccessApiService];
